module.exports = __webpack_public_path__ + "static/work42-7809a40248bf425e315f6feacf716087.jpg";